import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("app_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    // ONLY on a real 401 do we drop the token. Never navigate via
    // window.location -- that escapes mobile preview iframes and sends the
    // user to app.emergent.sh. Instead fire an in-app event so AuthContext
    // can transition state and React Router handles the redirect softly.
    if (err.response?.status === 401) {
      try {
        localStorage.removeItem("app_token");
        window.dispatchEvent(new Event("auth-expired"));
      } catch (e) {
        console.debug("401 cleanup failed:", e?.message);
      }
    }
    return Promise.reject(err);
  }
);

// Swallow unhandled axios rejections so transient 5xx / network blips
// don't surface as "Unhandled rejection" overlays in the preview.
if (typeof window !== "undefined") {
  window.addEventListener("unhandledrejection", (ev) => {
    const r = ev.reason;
    if (r && (r.isAxiosError || r.config || r.response)) {
      ev.preventDefault();
    }
  });
}

export const authedFileUrl = (path) => {
  const t = localStorage.getItem("app_token");
  return `${API_BASE}${path}${path.includes("?") ? "&" : "?"}auth=${t}`;
};

/**
 * Safely turn any axios error into a human-readable string.
 * FastAPI/Pydantic 422 returns `detail` as an array of error objects
 * ({type, loc, msg, input, ctx}) which React cannot render directly.
 */
export const errMsg = (err, fallback = "Something went wrong") => {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    return d
      .map((e) => {
        const field = Array.isArray(e?.loc) ? e.loc.filter((p) => p !== "body").join(".") : "";
        const msg = e?.msg || "invalid value";
        return field ? `${field}: ${msg}` : msg;
      })
      .join(" · ");
  }
  if (d && typeof d === "object") return d.message || JSON.stringify(d);
  return err?.message || fallback;
};
